import { IconProps } from "../../utils/global-types/global-types";

const OutboundArrowIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M12.778 4.563h-6.13a.65.65 0 0 0-.463.193.65.65 0 0 0-.193.464v.556a.665.665 0 0 0 .66.66l3.58.005-5.68 5.68a.64.64 0 0 0-.001.914l.393.394c.256.256.68.274.935.018l5.7-5.7-.006 3.61a.647.647 0 0 0 .652.652h.556c.175 0 .339-.07.463-.194a.65.65 0 0 0 .193-.464V5.222a.65.65 0 0 0-.194-.465.65.65 0 0 0-.465-.194"
    ></path>
  </svg>
);

export default OutboundArrowIcon;
